var _rect, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#BFFF0B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10V21C8 22.1046 8.89543 23 10 23H22C23.1046 23 24 22.1046 24 21V14C24 12.8954 23.1046 12 22 12H10C8.89543 12 8 11.1046 8 10V10ZM8 10V10C8 8.89543 8.89543 8 10 8H22",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 17.5,
    r: 1.5,
    fill: "black"
  })));
};
export { SvgWallet as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIGZpbGw9IiNCRkZGMEIiIC8+CiAgPHBhdGgKICAgIGQ9Ik04IDEwVjIxQzggMjIuMTA0NiA4Ljg5NTQzIDIzIDEwIDIzSDIyQzIzLjEwNDYgMjMgMjQgMjIuMTA0NiAyNCAyMVYxNEMyNCAxMi44OTU0IDIzLjEwNDYgMTIgMjIgMTJIMTBDOC44OTU0MyAxMiA4IDExLjEwNDYgOCAxMFYxMFpNOCAxMFYxMEM4IDguODk1NDMgOC44OTU0MyA4IDEwIDhIMjIiCiAgICBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJzcXVhcmUiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+CiAgPGNpcmNsZSBjeD0iMjAuNSIgY3k9IjE3LjUiIHI9IjEuNSIgZmlsbD0iYmxhY2siIC8+Cjwvc3ZnPg==";